//#region imports
import React, { useEffect, useState } from "react";

// redux
import { useSelector } from "react-redux";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";

// styling
import { Spacing, Colors } from "_styles";
import "./job-card.css"
import { statusCircle } from "./job-styles";

// utils
import { getTaskCardStatus, getTimeString, calculateMinuteDifference, getReadableTimeString, convertShiftTimeStamp } from "_utils/functions";
import TaskAccept from "./task-accept";
import { MdFreeBreakfast } from "react-icons/md";
import { EmployeeJobCardWidth, minute30MinLayoutWidth } from "../timeline-constants";
//#endregion

const BreakTaskCard = (props) => {

    //#region redux
    const dbUser = useSelector(selectFirebaseInfo);
    const showDetails = dbUser?.details?.authority === "DUB" || dbUser?.details?.authority == 'BFS' ? false : true;     // dont show details for BFS or DUB
    //#endregion

    //#region local states
    const [jobStatusLine, setJobStatusLine] = useState("Not Assigned");                                             // status of job

    let minWidth = EmployeeJobCardWidth + 10;  // Match job-card-container.js
    const [width, setWidth] = useState(minWidth);                                                                               // width of job card

    // height functionality (same as job-card-container.js)
    let maxHeight = '45px';
    let minHeight = '22.5px';
    const [height, setHeight] = useState(minHeight);

    // Check if break is in the past (based on breakEndTime)
    const [isInPast, setIsInPast] = useState(false);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    //#endregion

    //#region useEffects

    // set job states if it is a isBreakTask 
    const toHHMM = (date) =>
        `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;

    useEffect(() => {
        if (props?.job?.isBreakTask) {
            const startTs = props?.job?.breakTaskInformation?.breakStartTime;
            const endTs = props?.job?.breakTaskInformation?.breakEndTime;

            if (!startTs?.seconds) return;

            const startDate = new Date(startTs.seconds * 1000);
            const endDate = endTs?.seconds ? new Date(endTs.seconds * 1000) : null;

            const startTimeHHMM = toHHMM(startDate);
            const endTimeHHMM = endDate ? toHHMM(endDate) : null;

            setStartTime(startTimeHHMM);
            setEndTime(endTimeHHMM);
        }
    }, [props.job]);


    // Check if break is in the past based on breakEndTime
    useEffect(() => {
        const checkIfPast = () => {
            if (props?.job?.breakTaskInformation?.breakEndTime) {
                const endTime = new Date(props.job.breakTaskInformation.breakEndTime.seconds * 1000);
                const now = new Date();
                setIsInPast(endTime < now);
            } else if (props?.job?.completed) {
                // If completed, consider it in the past
                setIsInPast(true);
            }
        };

        checkIfPast();

        // Re-check every minute
        const interval = setInterval(checkIfPast, 60000);
        return () => clearInterval(interval);
    }, [props?.job?.breakTaskInformation?.breakEndTime, props?.job?.completed]);

    // calculate width based on break start and end time when thirtyMinLayout is enabled
    useEffect(() => {
        if (props?.thirtyMinLayout && props?.job?.breakTaskInformation?.breakStartTime && props?.job?.breakTaskInformation?.breakEndTime) {
            // Convert timestamps to Date objects
            const startTime = new Date(props.job.breakTaskInformation.breakStartTime.seconds * 1000);
            const endTime = new Date(props.job.breakTaskInformation.breakEndTime.seconds * 1000);

            // Calculate difference in minutes directly from Date objects (handles midnight crossing)
            const widthInMinutes = Math.round((endTime - startTime) / 60000);

            // Calculate width in pixels (minute30MinLayoutWidth pixels per minute)
            const calculatedWidth = Math.max(widthInMinutes * minute30MinLayoutWidth, EmployeeJobCardWidth);

            setWidth(calculatedWidth);
        } else {
            // Default width when thirtyMinLayout is not enabled (hour layout)
            // Match job-card-container.js which uses EmployeeJobCardWidth + 10
            setWidth(EmployeeJobCardWidth + 10);
        }
    }, [props?.thirtyMinLayout, props?.job?.breakTaskInformation?.breakStartTime, props?.job?.breakTaskInformation?.breakEndTime]);


    //#endregion

    const displayBreakTaskTimes = () => {

        let fullTime = "--:--";
        if (!props.job) return fullTime;

        if (props.job.pending) {
            fullTime = convertShiftTimeStamp(props.job.allocatedTime);
        }
        if (props.job.active) {
            fullTime = convertShiftTimeStamp(props.job.startTime);
        }
        if (props.job.stopped) {
            const startTime = convertShiftTimeStamp(props.job.startTime);
            const stopTime = convertShiftTimeStamp(props.job.stopTime)
            fullTime = `${startTime}-${stopTime}`
        }
        if (props.job.completed) {
            const startTime = convertShiftTimeStamp(props.job.startTime);
            const completeTime = convertShiftTimeStamp(props.job.completeTime)
            fullTime = `${startTime}-${completeTime}`
        }
        if (!props.job.active && !props.job.completed && !props.job.stopped) {
            fullTime = props.job.assignedTime
        }

        return fullTime
    }

    return (
        <>
            {/* SIRAN: OUTER DIV HAS NO EFFECT */}
            {/* outer container - matches job-card-container.js for positioning */}
            {/* <div style={{
                position: 'relative',
                overflowY: 'hidden',
                width: width,
                minWidth: EmployeeJobCardWidth,
                height: props?.showFullCard ? maxHeight : props?.thirtyMinLayout ? height : maxHeight,
                display: "flex",
                justifyContent: "center",
                alignItems: 'center',
                opacity: isInPast ? 0.5 : 1,
                transition: 'opacity 0.3s ease',
                border: '1px solid blue'

            }}> */}
            {/* job card */}
            <div
                onContextMenu={(e) => { console.log('break task: ', props?.job), props.handleLeftClick(e) }}
                onDoubleClick={(e) => { props.handleLeftClick(e) }}
                onClick={(e) => { props.handleJobClick(e) }}
                onMouseOver={() => { setHeight(maxHeight); }}
                onMouseOut={() => { setHeight(minHeight); }}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    position: 'relative',
                    overflowY: 'hidden',
                    borderWidth: '1px',
                    borderColor: 'lightgray',
                    borderRadius: 5,
                    color: 'black',
                    cursor: 'pointer',
                    minWidth: EmployeeJobCardWidth,
                    width: width,
                    height: props?.showFullCard ? maxHeight : props?.thirtyMinLayout ? height : maxHeight,
                    opacity: isInPast ? 0.5 : 1,
                }}
            >

                {/* top half of card */}
                <div style={{
                    backgroundColor: Colors.ORANGE, padding: Spacing.SCALE_4, overflow: 'hidden', borderRadius: 5,
                }}>

                    {/* break task label */}
                    <div style={{ display: "flex", justifyContent: "space-between", flex: 1 }}>
                        <p style={{ margin: "0px 0", textAlign: "center", fontSize: 11, fontWeight: '600', color: 'white' }}>
                            {'Break Task'}
                        </p>

                        {/* icon */}
                        <MdFreeBreakfast
                            size={12}
                            color={"white"}
                            style={{}}
                        />
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", flex: 1 }}>
                        <span style={{ margin: "0px 0", textAlign: "center", fontSize: 11, fontWeight: '600', color: 'white' }}>{startTime}</span>
                        <span style={{ margin: "0px 0", textAlign: "center", fontSize: 11, fontWeight: '600', color: 'white' }}>{endTime}</span>
                    </div>

                </div>

                {/* horizontal line break - only show when expanded and Dublin user */}
                {showDetails && (props?.showFullCard || !props?.thirtyMinLayout || height === maxHeight) && (
                    <>
                        <hr style={{ margin: "0px", color: 'white' }} />

                        {/* bottom half of card - only show when expanded */}
                        <div style={{ padding: Spacing.SCALE_4, display: "flex", justifyContent: "space-between", position: "relative", alignItems: "baseline" }}>

                            {/* status color icon / check in icon */}
                            <p style={{ margin: "0px 0", fontSize: 10, fontWeight: "500" }}>{displayBreakTaskTimes()}</p>

                            {/* status icon */}
                            <div style={{ display: "flex", position: "relative", alignItems: "center" }}>

                                {/* status circle */}
                                <div style={{
                                    ...statusCircle,
                                    backgroundColor: props?.job?.cancelled ? 'red' : props?.job?.active ? Colors.GREEN : props?.job?.completed ? Colors.GREEN : 'grey'
                                }} />

                                {/* status text */}
                                <p style={{
                                    margin: "0px", textAlign: "right",
                                    fontSize: 10,
                                    color: props?.job?.cancelled ? 'red' : props?.job?.active ? Colors.GREEN : props?.job?.completed ? Colors.GREEN : 'grey',
                                    fontWeight: "700",
                                    whiteSpace: 'nowrap',
                                    marginLeft: Spacing.SCALE_2
                                }}>{jobStatusLine}</p>
                            </div>

                        </div>
                    </>
                )}

            </div>
            {/* </div> */}

            {/* task accept modal */}
            <TaskAccept
                task={props?.job}
                closeModal={props?.closeModal}
                toggleAcceptModal={props?.toggleAcceptModal}
            />
        </>
    );
};

export default BreakTaskCard;
